import { ProductionReportPage } from "./ProductionReportPage";

const ProductionReport = () => {
  return <ProductionReportPage />;
};

export default ProductionReport;
